











import Vue, { PropType } from "vue";
import ice from "../../lib/ice";

export interface VueApplyPlanButtonProps {
  href: string;
  ipadHref: string;
  target: string;
  serial: string;
  notInstalledMessage: string;
  isLaunchPaintWithCallIce: boolean;
}

export default Vue.extend({
  name: "vc-open-clip-studio-paint-button",
  props: {
    href: {
      type: String as PropType<VueApplyPlanButtonProps["href"]>,
      default: ""
    },
    ipadHref: {
      type: String as PropType<VueApplyPlanButtonProps["ipadHref"]>,
      default: ""
    },
    target: {
      type: String as PropType<VueApplyPlanButtonProps["target"]>,
      default: ""
    },
    serial: {
      type: String as PropType<VueApplyPlanButtonProps["serial"]>,
      default: ""
    },
    notInstalledMessage: {
      type: String as PropType<VueApplyPlanButtonProps["notInstalledMessage"]>,
      default:
        "CLIP STUDIO PAINTが起動しない場合、:brCLIP STUDIO PAINTを再インストールしてください。"
    },
    isLaunchPaintWithCallIce: {
      type: Boolean as PropType<
        VueApplyPlanButtonProps["isLaunchPaintWithCallIce"]
      >,
      default: true
    }
  },
  computed: {
    computedHref(): string {
      const agent = window.navigator.userAgent.toLowerCase();
      const ipad =
        agent.indexOf("ipad") > -1 ||
        (agent.indexOf("macintosh") > -1 && "ontouchend" in document);
      if (ipad) {
        return this.ipadHref;
      } else {
        return this.href;
      }
    }
  },
  methods: {
    onClickButton(e: Event) {
      if (ice.isIce()) {
        ice.runPaint(this.serial);
        e.preventDefault();
      } else {
        if (this.isLaunchPaintWithCallIce) {
          let setTimeoutId = setTimeout(() => {
            alert(this.notInstalledMessage.replace(":br", "\n"));
          }, 2000);
          window.addEventListener("blur", event => {
            clearTimeout(setTimeoutId);
            if (typeof window.CustomEvent === "function") {
              let callIceEvent = new CustomEvent("callIce");
              window.dispatchEvent(callIceEvent);
            }
          });
        }
      }
    }
  }
});
